if (typeof AFRAME === 'undefined') {
  throw new Error('Component attempted to register before AFRAME was available.');
}

AFRAME.registerComponent('trunk', {
  schema: {
    on: { default: 'click' },
    clue: { type: 'string', default: '#panel-trunk' },
    opensnd: { type: 'string', default: 'trunkopensound' },
    coinsnd: { type: 'string', default: 'trunkcoinsound' },    
    clickAction: {type: 'string'},
  },

  init: function() {
    var data = this.data;
    var el = this.el;
    var opensound = this.opensound = document.getElementById(data.opensnd);
    var coinsound = this.coinsound = document.getElementById(data.coinsnd);
    
    el.setAttribute('geometry', `primitive:box; width:1; height:1;depth:1`);
    el.setAttribute('material', `transparent: true; opacity:0; color:#fff;`);

    var base = document.createElement("a-entity");
    base.setAttribute('obj-model', `obj: #trunk_base-obj; mtl: #trunk_base-mtl`);
    base.setAttribute('scale', '0.5 0.5 0.5');
    base.setAttribute('position', '0 0 0');
    el.appendChild(base);

      
    var lid = document.createElement("a-entity");
    lid.setAttribute('obj-model', `obj: #trunk_top-obj; mtl: #trunk_top-mtl`);
    lid.setAttribute('scale', '0.5 0.5 0.5');
    lid.setAttribute('position', '0 0 0');
    el.appendChild(lid);

    var trunklidAni = document.createElement("a-animation");
    trunklidAni.setAttribute('attribute', 'rotation');
    trunklidAni.setAttribute('begin', 'reveal');
    trunklidAni.setAttribute('to', '-120 0 0' );   
    trunklidAni.setAttribute('delay', '0');
    trunklidAni.setAttribute('dur', '1500');
    trunklidAni.setAttribute('fill', 'forwards');
    lid.appendChild(trunklidAni);


    var shadow = document.createElement("a-entity");
    shadow.setAttribute('geometry', `primitive:plane; width:1.2; height:0.7;`);
    shadow.setAttribute('material', `color:#2d283d; opacity:0.5`);
    shadow.setAttribute('rotation', '-90 0 0');
    shadow.setAttribute('position', '0 -0.45 0.3');
    el.appendChild(shadow);

    var coin = document.createElement("a-entity");
    coin.setAttribute('geometry', 'primitive:cylinder; radius:0.175; height:0.05;');
    coin.setAttribute('material', 'color:#fcc137; opacity:1;');
    coin.setAttribute('scale', '0.5 0.5 0.5');
    coin.setAttribute('rotation', '90 0 0');
    coin.setAttribute('position', '0 -0.150 0.3');
    el.appendChild(coin);

    var coinAniPos = document.createElement("a-animation");
    coinAniPos.setAttribute('attribute', 'position');
    coinAniPos.setAttribute('begin', 'reveal');
    coinAniPos.setAttribute('from', '0 -0.150 0.3' );   
    coinAniPos.setAttribute('to', '0 0.75 0.3' );   
    coinAniPos.setAttribute('delay', '1800');
    coinAniPos.setAttribute('dur', '500');
    coinAniPos.setAttribute('fill', 'forwards');
    coin.appendChild(coinAniPos);

    var coinAniRot = document.createElement("a-animation");
    coinAniRot.setAttribute('attribute', 'rotation');
    coinAniRot.setAttribute('begin', 'reveal');
    coinAniRot.setAttribute('from', '90 0 0' );   
    coinAniRot.setAttribute('to', '90 360 0' );   
    coinAniRot.setAttribute('delay', '1800');
    coinAniRot.setAttribute('dur', '750');
    coinAniRot.setAttribute('fill', 'forwards');
    coin.appendChild(coinAniRot);

    var coinAniScale = document.createElement("a-animation");
    coinAniScale.setAttribute('attribute', 'scale');
    coinAniScale.setAttribute('begin', 'reveal');
    coinAniScale.setAttribute('from', '0.5 0.5 0.5' );   
    coinAniScale.setAttribute('to', '1 1 1' );   
    coinAniScale.setAttribute('delay', '1800');
    coinAniScale.setAttribute('dur', '250');
    coinAniScale.setAttribute('fill', 'forwards');
    coin.appendChild(coinAniScale);

    var coinAniAlpha = document.createElement("a-animation");
    coinAniAlpha.setAttribute('attribute', 'material.opacity');
    coinAniAlpha.setAttribute('begin', 'reveal');
    coinAniAlpha.setAttribute('from', '1' );   
    coinAniAlpha.setAttribute('to', '0' );   
    coinAniAlpha.setAttribute('delay', '2000');
    coinAniAlpha.setAttribute('dur', '400');
    coinAniAlpha.setAttribute('fill', 'forwards');
    coin.appendChild(coinAniAlpha);


    var trunkclue = document.createElement("a-entity");
    trunkclue.setAttribute('geometry', `primitive:plane; width:0.75; height:0.36;`);
    trunkclue.setAttribute('material', `color:#fff; transparent:true; src:${data.clue}; side:double`);
    trunkclue.setAttribute('rotation', '0 0 0');
    trunkclue.setAttribute('position', '0 0.75 0.4');
    trunkclue.setAttribute('scale', '0 0 0');     
    el.appendChild(trunkclue);

    var trunkclueAniScale = document.createElement("a-animation");
    trunkclueAniScale.setAttribute('attribute', 'scale');
    trunkclueAniScale.setAttribute('begin', 'reveal');
    trunkclueAniScale.setAttribute('to', '1 1 1' );   
    trunkclueAniScale.setAttribute('delay', '2500');
    trunkclueAniScale.setAttribute('dur', '500');
    trunkclueAniScale.setAttribute('fill', 'forwards');
    trunkclue.appendChild(trunkclueAniScale);

    var shut = true;

    el.addEventListener(data.on, function (evt) {            

        console.log('Trunk was clicked at: ', evt.detail.intersection.point);

        if (shut){        
            lid.emit('reveal');
            coin.emit('reveal');
            trunkclue.emit('reveal');

            opensound.components.sound.stopSound(); opensound.components.sound.playSound();
            setTimeout(function(){ 
                coinsound.components.sound.stopSound(); coinsound.components.sound.playSound();
            }, 2500);
            
            shut = false;
        }

        var clickActionFunctionName = data.clickAction;
        console.log("in trunk, clickActionFunctionName: "+clickActionFunctionName);
        // find object
        var clickActionFunction = window[clickActionFunctionName];
        //console.log("clickActionFunction: "+clickActionFunction);
        // is object a function?
        if (typeof clickActionFunction === "function") clickActionFunction();
    });


  },
  setClickAction: function (action) {
    this.data.clickAction = action; //change function dynamically
  },
  play: function () {
  },
  update: function (oldData) {
  },
});


// WEBPACK FOOTER //
// ./src/aframe/components/trunk.js